import { ReactNode } from 'react'
import styled from 'styled-components'
import { Grid, Wrapper } from '@farewill/ui'
import { BORDER, COLOR, GTR } from '@farewill/ui/tokens'

import NotesField from './notes-field'
import SectionHeading, { SectionToggle } from './section-heading'

const StyledCard = styled(Wrapper)`
  background-color: ${COLOR.WHITE};
  border: 1px solid ${COLOR.GREY.LIGHT};
  border-radius: ${BORDER.RADIUS.M};
  box-shadow: ${BORDER.SHADOW.M};
  padding: ${GTR.M};
`

const StyledFooter = styled.div`
  margin-top: ${GTR.L};
`

type Props = {
  heading: string
  scrollId?: string
  notesName?: string
  onNotesSave?: ({ name, value }: { name: string; value: string }) => void
  toggle?: SectionToggle
  summary?: ReactNode
  footer?: ReactNode
  // without any, the card holds just the notes
  children?: ReactNode
}

const Section = ({
  heading,
  scrollId,
  notesName,
  onNotesSave,
  toggle,
  summary,
  footer,
  children,
}: Props) => (
  <div
    data-scroll-id={scrollId}
    data-testid={scrollId && `section-${scrollId}`}
  >
    <SectionHeading heading={heading} toggle={toggle} />
    {(!toggle || toggle.isOn) && (
      <>
        {summary}
        <StyledCard>
          {children && <Grid gap="M">{children}</Grid>}
          {notesName && (
            <NotesField
              name={notesName}
              handleSave={onNotesSave}
              standalone={!children}
            />
          )}
        </StyledCard>
        {footer && (
          <StyledFooter data-testid="section-footer">{footer}</StyledFooter>
        )}
      </>
    )}
  </div>
)

export default Section
